<template>
  <div class="media-box">
    <div class="media-item">
      <i
        class="el-icon-wei2"
        @click="handleShowWechat" />
      <div class="media-name">{{ t('footer.WeChatofficial') }}</div>
    </div>
    <div class="media-item">
      <i
        class="el-icon-applet"
        @click="handleShowMini" />
      <div class="media-name">{{ t('footer.WeChat_applet') }}</div>
    </div>
    <ClientOnly>
      <el-dialog
        v-model="dialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :title="dialogTitle"
        append-to-body
        class="preview-component"
        destroy-on-close
        width="400px">
        <img
          :alt="dialogTitle"
          :src="dialogImg"
          rel="nofollow,noindex" />
        <div class="desc">{{ t('footer.desc') }}</div>
      </el-dialog>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { fetchCreateWXACode } from '~~/server/api/tripartite'
// 国际化
const { t } = useI18n()

// 响应式数据
const dialogVisible = ref(false)
const dialogTitle = ref('')
const dialogImg = ref('')

// 显示微信公众号二维码
const handleShowWechat = async () => {
  dialogVisible.value = true
  dialogTitle.value = t('footer.scan_follow') as string
  dialogImg.value = (await import('~/assets/images/juzhan-gh.webp')).default
}

// 显示微信小程序二维码
const handleShowMini = async () => {
  dialogVisible.value = true
  dialogTitle.value = t('footer.scan_openApplet') as string
  dialogImg.value = (await import('~/assets/images/juzhan-mini.webp')).default
  getQrcode()
}
const route = useRoute()
const getQrcode = async () => {
    const res = await fetchCreateWXACode(
      {
        page: 'views/exh-info/exh-info',
        scene: `id=${route.params.id}`,
        checkPath: true,
        autoColor: false,
        lineColor: { r: 0, g: 0, b: 0 },
        envVersion: 'release'
      },
      { responseType: 'arrayBuffer' }
    )
    const blob = new Blob([res as any], { type: 'image/png' })
    const blobUrl = URL.createObjectURL(blob)
    dialogImg.value = blobUrl
  }
</script>

<style lang="less" scoped>
  .media-box {
    display: flex;
    gap: 16px;

    .media-item {
      display: flex;
      gap: 8px;
      flex-direction: column;
      align-items: center;

      .media-name {
        font-size: 12px;
        color: #999;
        white-space: nowrap;
      }
    }

    i {
      width: 32px;
      overflow: hidden;
      border-radius: 50%;
      margin-left: 14px;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }

      &::before {
        font-size: 32px !important;
      }
    }
  }
</style>

<style lang="less">
  .preview-component {
    .el-dialog {
      border-radius: 8px;
    }

    .el-dialog__close {
      font-size: 22px;
    }

    .el-dialog__body {
      padding: 32px 0 54px !important;
      text-align: center;
    }

    img {
      width: 220px;
    }

    .desc {
      font-size: 14px;
      color: #333;
      text-align: center;
      margin-top: 32px;
    }
  }
</style>
